import { useCallback, useState } from "react";

import client from "../client";
import { handleToast } from "../../utils/functions";
import handleApiError from "../../hooks/handleApiError";

export default function useAddBehavourialSkillRemark() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (reportCardId, payload) => {
    try {
      const { data } = await client.patch(
        `/result/reportcard/updateBehavourialSkills/${reportCardId}`,
        payload
      );
      setLoading(false);
      handleToast(data?.message);
      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading };
}
